// extracted by mini-css-extract-plugin
export var linkText = "_oj-0";